import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { reviewService } from '../services/reviewService';
import Layout from '../components/Layout';

const Review = () => {
  const { appointmentId } = useParams();
  const navigate = useNavigate();
  const [rating, setRating] = useState(5);
  const [comment, setComment] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (rating < 1 || rating > 5) {
      setError('Proszę wybrać ocenę od 1 do 5');
      return;
    }

    setSubmitting(true);
    try {
      await reviewService.create(appointmentId, rating, comment);
      alert('Dziękujemy za opinię!');
      navigate('/appointments');
    } catch (err) {
      setError(
        err.response?.data?.detail ||
          'Nie udało się dodać opinii. Spróbuj ponownie.'
      );
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Layout>
      <div className="container mx-auto px-4 py-8">
        <div className="max-w-2xl mx-auto">
          <h1 className="text-3xl font-bold text-ik-black mb-8">
            Wystaw opinię
          </h1>

          <div className="bg-white rounded-lg shadow-md p-8">
            <form onSubmit={handleSubmit}>
              {error && (
                <div className="bg-red-50 border border-red-400 text-red-700 px-4 py-3 rounded mb-4">
                  {error}
                </div>
              )}

              <div className="mb-6">
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Ocena
                </label>
                <div className="flex space-x-2">
                  {[1, 2, 3, 4, 5].map((star) => (
                    <button
                      key={star}
                      type="button"
                      onClick={() => setRating(star)}
                      className={`text-4xl ${
                        star <= rating ? 'text-ik-orange' : 'text-gray-300'
                      } hover:text-ik-orange transition`}
                    >
                      ★
                    </button>
                  ))}
                </div>
                <p className="text-sm text-gray-600 mt-2">
                  Wybrana ocena: {rating}/5
                </p>
              </div>

              <div className="mb-6">
                <label
                  htmlFor="comment"
                  className="block text-sm font-medium text-gray-700 mb-2"
                >
                  Komentarz (opcjonalnie)
                </label>
                <textarea
                  id="comment"
                  rows="6"
                  value={comment}
                  onChange={(e) => setComment(e.target.value)}
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-ik-orange focus:border-ik-orange"
                  placeholder="Podziel się swoją opinią o wizycie..."
                />
              </div>

              <div className="flex space-x-4">
                <button
                  type="submit"
                  disabled={submitting}
                  className="flex-1 px-6 py-2 bg-ik-orange text-white rounded-lg hover:bg-orange-600 transition font-semibold disabled:opacity-50"
                >
                  {submitting ? 'Wysyłanie...' : 'Wyślij opinię'}
                </button>
                <button
                  type="button"
                  onClick={() => navigate('/appointments')}
                  className="px-6 py-2 border-2 border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition"
                >
                  Anuluj
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default Review;
